const tableEls = document.querySelectorAll('.contentFormat table');

tableEls.forEach((tableEl, index) => {    
    const parentEl = tableEl.parentNode;
    const tableWrapEl = document.createElement('div');
    tableWrapEl.classList.add('table-wrap');  
    
    parentEl.replaceChild(tableWrapEl, tableEl);
    tableWrapEl.appendChild(tableEl);
});